var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-fixed d-flex flex-column"},[_c('transition-group',{attrs:{"name":"notifications"}},_vm._l((_vm.alerts),function(alert){return _c('audi-notification',{key:alert.notification.id,staticClass:"mb-1",attrs:{"notification":alert.notification,"announcement":alert.isAnnouncement}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }